import Typography from '@mui/material/Typography';
import { PrimaryButton } from 'sharedComponents/Buttons';
import React from 'react';
import { BoltOutlined } from '@mui/icons-material';

interface QuickApplyButtonProps {
  sx?: object;
  buttonText?: string;
  fontSize?: string;
  disabled?: boolean;
  onClick?: () => void;
  showIcon?: boolean;
}

export const QuickApplyButton: React.FC<QuickApplyButtonProps> = ({
  sx,
  buttonText = 'Quick Apply',
  showIcon = true,
  fontSize = '14px',
  disabled = false,
  onClick,
}) => {
  return (
    <PrimaryButton
      size="small"
      disabled={disabled}
      startIcon={showIcon && <BoltOutlined />}
      sx={{
        ...buttonStyles,
        ...sx,
      }}
      onClick={onClick}
    >
      <Typography noWrap style={{ fontSize: fontSize, fontWeight: 600 }}>
        {buttonText}
      </Typography>
    </PrimaryButton>
  );
};
const buttonStyles = {
  backgroundColor: (theme) => theme.palette.purple.dark,
  borderRadius: '8px',
  height: '44px',
  padding: '14px',

  '&:hover': {
    backgroundColor: (theme) => theme.palette.purple.darker,
  },
};
